(function () {
  function stopEvent(event) {
    if (!event) return;
    event.preventDefault();
    event.stopPropagation();
  }

  function goToCheckout() {
    window.location.assign('/checkout');
  }

  function addSelectedProductAndCheckout(event) {
    stopEvent(event);

    var productForm = event && event.currentTarget
      ? event.currentTarget.closest('product-form')
      : null;
    var form = productForm
      ? productForm.querySelector('form[action*="/cart/add"]')
      : null;

    if (!form) {
      goToCheckout();
      return;
    }

    var buttons = form.querySelectorAll('button');
    buttons.forEach(function (button) {
      button.disabled = true;
    });

    fetch(window.routes && window.routes.cart_add_url ? window.routes.cart_add_url : '/cart/add.js', {
      method: 'POST',
      headers: {
        Accept: 'application/json',
        'X-Requested-With': 'XMLHttpRequest',
      },
      body: new FormData(form),
    })
      .then(function (response) {
        if (!response.ok) throw new Error('Unable to add the selected product to cart.');
        goToCheckout();
      })
      .catch(function (error) {
        console.error(error);
        buttons.forEach(function (button) {
          button.disabled = false;
        });
      });
  }

  if (typeof window.itcProdPageCheckout !== 'function') {
    window.itcProdPageCheckout = addSelectedProductAndCheckout;
  }
  if (typeof window.itcProdPagePayPal !== 'function') {
    window.itcProdPagePayPal = addSelectedProductAndCheckout;
  }
  if (typeof window.itcCartDrawerCheckout !== 'function') {
    window.itcCartDrawerCheckout = function (event) {
      stopEvent(event);
      goToCheckout();
    };
  }
  if (typeof window.itcCartDrawerPayPal !== 'function') {
    window.itcCartDrawerPayPal = function (event) {
      stopEvent(event);
      goToCheckout();
    };
  }
})();
